export const CHAIN_INFO = {
  chainId: 'tDVW',
  exploreUrl: 'https://testnet.aelfscan.io/tDVW/',
  rpcUrl: 'https://tdvw-test-node.aelf.io',
};

export const TOKEN_CONTRACT = 'ASh2Wt7nSEmYqnGxPPzp4pnVDU4uhj1XW9Se5VeZcX2UDdyjx';
export const ETRANSFER_CONTRACT = '2AgU8BfyKyrxUrmskVCUukw63Wk96MVfVoJzDDbwKszafioCN1';
export const CA_CONTRACT = '2WzfRW6KZhAfh3gCZ8Akw4wcti69GUNc1F2sXNa2fgjndv59bE';
export const CA_CONTRACT_V2 = '238X6iw1j8YKcHvkDYVtYVbuYk2gJnK8UoNpVCtssynSpVC8hb';
